/**
 * Production singleton for `WSClient`.
 *
 * Why this is a separate file
 * ───────────────────────────
 * `WSClient.ts` is the pure class — it has no module-load-time side effects
 * so it can be imported and unit-tested under Node (vitest). The browser-only
 * default URL + auth params come from `../../api/config`, whose initializer
 * reads `window.location` at module load. Importing `config` from `WSClient.ts`
 * would crash every test that tries to import `WSClient`.
 *
 * App code imports the singleton from THIS file. Tests import `WSClientImpl`
 * from `WSClient.ts` directly and inject their own deps.
 *
 * Reference: `/workspace/.cursor/plans/websocket_robustness_refactor_b886ced2.plan.md`
 */

import { WEBSOCKET_URL, getWsAuthParams } from '../../api/config';
import { WSClientImpl } from './WSClient';

export { WSClientImpl, WSClientDocMismatchError } from './WSClient';
export type { WSClientHandle, WSClientOpenOptions, WSClientDeps } from './WSClient';

/**
 * App-wide WebSocket client singleton.
 *
 * Use `wsClient.open({ roomname, doc, ... })` instead of constructing a
 * `WebsocketProvider` directly. The handle's `close()` is the canonical
 * cleanup — call it when the consumer is done with the room (typically in
 * a `useEffect` cleanup or component `dispose()` method).
 */
export const wsClient = new WSClientImpl({
	url: WEBSOCKET_URL,
	paramsProvider: getWsAuthParams,
});
